import type { GridItem } from '../services/grid-service';

export enum ContextMenuItemKey {
  // Common items
  copyLink = 'copyLink',
  details = 'details',
  
  // Submission items
  publishSubmission = 'publishSubmission',
  editSubmission = 'editSubmission',
  deleteSubmission = 'deleteSubmission',
  
  // Section items
  add = 'add',
  addFiles = 'addFiles',
  addFolder = 'addFolder',
  createNewContextGroup = 'createNewContextGroup',
  editContextGroup = 'editContextGroup',
  deleteContextGroup = 'deleteContextGroup',
  pasteAsReused = 'pasteAsReused',
  editFolder = 'editFolder',
  deleteFolder = 'deleteFolder',
  
  // File items
  editFileName = 'editFileName',
  editFileTitle = 'editFileTitle',
  updateDocumentElements = 'updateDocumentElements',
  replaceFiles = 'replaceFiles',
  copyForReused = 'copyForReused',
  suspendFile = 'suspendFile',
  removeSuspension = 'removeSuspension',
  downloadFile = 'downloadFile',
  deleteFile = 'deleteFile'
}

export enum ContextMenuItemStyle {
  default = 'default',
  success = 'success',
  danger = 'danger'
}

export enum FileUseState {
  Current = 1,
  Deleted = 2,
  Suspended = 3
}

export enum ActionType {
  Original = 1,
  Replace = 2,
  Amendment = 3,
  Variation = 4
}

export enum NodeType {
  Sub = 1,
  Unit = 2,
  Section = 3,
  RepeatSection = 4,
  SectionExtension = 5,
  FileUseHistory = 6,
  FileUseSet = 7
}

export enum TreeType {
  Lifecycle = 1,
  Current = 2,
  Activities = 3,
  Sequence = 4,
  Origin = 5,
  Search = 6
}

export interface ContextMenuSubItem {
  id: ContextMenuItemKey;
  displayText: string;
}

export interface ContextMenuItem {
  key: ContextMenuItemKey;
  displayText: string;
  order: number;
  style: ContextMenuItemStyle;
  disabled: boolean;
  items: ContextMenuSubItem[];
  isDropdown: boolean;
  icon?: string;
  divider?: boolean;  // Add divider after this item
}

export interface ContextMenuContext {
  companyId: number;
  appId: number;
  activeTreeType: TreeType;
  selectedNode: TreeNode | GridItem | null;  // TreeComponent equivalent
  userRights?: UserRights;  // User permissions
}

export interface TreeNode {
  Id: number;
  NodeType: NodeType;
  NodeTypeId: number;
  DoesExist: boolean;
  IsPlaceholder: boolean;
  FileUseStateId?: FileUseState;
  ActionType?: ActionType;
  AllowFiles?: boolean;
  AllowSectionExtensions?: boolean;
  TreeTypeId: TreeType;
  Name?: string;
  Path?: string;
  IsFolder?: boolean;
  // Additional properties as needed
}

export interface UserRights {
  canEdit: boolean;
  canDelete: boolean;
  canCreate: boolean;
  // Additional permissions as needed
}

export interface TreeComponent {
  Id: number;
  NodeType: NodeType;
  NodeTypeId: number;
  SubId?: number;
  DoesExist: boolean;
  IsPlaceholder: boolean;
  FileUseStateId?: FileUseState;
  ActionType?: ActionType;
  AllowFiles?: boolean;
  AllowSectionExtensions?: boolean;
  TreeTypeId: TreeType;
  // Additional properties as needed
}

export interface ContextMenuPosition {
  x: number;
  y: number;
}